











































































































































import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
import themes from "@/store/modules/themes";
import { Theme } from "@/store/models";
import ColorPicker from "./ColorPicker.vue";

@Component({
  components: {
    ColorPicker
  }
})
export default class EditorPane extends Vue {
  constructor() {
    super();
  }

  pickColor: string = "#f2c811";

  themeObject: Theme = themes.getTheme;

  name: string = this.themeObject.name;

  get dataColors() {
      return themes.getDataColors;
  }

  updateValue(id, e) {
    const object = { index: id, color: e.hex };
    themes.updateDataColor(object);
  }

  removeValue(i) {
    themes.removeDataColor(i);
  }

  setName(e) {
    themes.setName(e);
  }

  clearAll() {
    themes.clearDataColors();
  }

  setBackgroundColor(e) {
    this.themeObject.background = e;
    themes.setTheme(this.themeObject);
  }

  setForegroundColor(e) {
    this.themeObject.foreground = e;
    themes.setTheme(this.themeObject);
  }

  setTableAccentColor(e) {
    this.themeObject.tableAccent = e;
    themes.setTheme(this.themeObject);
  }

  /**
   * Add Color
   */
  @Emit("apply-theme")
  addColor() {
    //this.dataColors.push(this.pickColor);

    themes.t(this.pickColor);
    //this.$emit('apply-theme', 'hello')
  }

  public setColor(e) {
    this.pickColor = e;
    //this.$forceUpdate();
  }
}
